module.exports = __webpack_public_path__ + "img/92111.5b0cedf5.svg";